import { gateway } from "../../../../../gateway";

export const postInviteIndiviual = async (data, token) => {
  const res = await gateway.post("/invitations/", data, {
    headers: {
      Authorization: `${token}`,
    },
  });
  return res.data || res.data.data;
};
